import { render } from "./App.vue?vue&type=template&id=91cf60b2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=91cf60b2&lang=scss"

import exportComponent from "/home/runner/work/1-fbk-tabor/1-fbk-tabor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__